/* eslint-disable no-script-url */
import React, { Component } from 'react';
import Dropdown, { DropdownContent, DropdownTrigger } from 'react-simple-dropdown';
import Avatar from './Avatar';

class NavbarDropdown extends Component {

    render(){
        const { user, userLogout } = this.props;
        return (
            <Dropdown ref='dropdown'>
                <div className="triangle"></div>
                <DropdownTrigger>
                   <Avatar /> 
                   <span className='dropdown__username'>{ user ? (user.uname).toUpperCase() : '' } </span>
                </DropdownTrigger>
                <DropdownContent>
                    <ul>
                        <li>
                            <a href="/"> WIDTHRAW </a>
                        </li>
                        <li>
                           <a href="/"> SETTINGS </a>
                        </li>
                        <li>
                        <a href="javascript:void()" 
                        onClick={userLogout}> 
                            LOGOUT 
                        </a>
                        </li>
                    </ul>
                </DropdownContent>
            </Dropdown>
        )
    }
}

export default NavbarDropdown;


// WEBPACK FOOTER //
// ./src/components/common/NavbarDropdown.js